<div class="detail-container">
    <nb-card [nbSpinner]="!!(saving$|async)">
        <nb-card-header>
            <button nbButton ghost status="primary" (click)="navigateBack()">
                <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
            </button>
            <h5>Ordner</h5>
            @if (canEdit() && !isNew()) {
                <wr-edit-delete-button-group (edit)="onEdit()"
                                             (delete)="onDelete()"></wr-edit-delete-button-group>
            }
        </nb-card-header>
        <nb-card-body>
            @if (form) {
                <form [formGroup]="form">
                    <div class="sub-card-body">
                        <input hidden formControlName="id">
                        <div class="grid">
                            <div class="md:col-4">
                                <label class="label" for="name">Name</label>
                                <input fullWidth id="name" type="text" nbInput formControlName="name"
                                       [readonly]="!isEditing" required>
                                @if (hasError('name')) {
                                    <div class="error">Name ist erforderlich!</div>
                                }
                            </div>
                            <div class="md:col-6">
                                <label class="label" for="color">Farbe</label>
                                <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
                                @if (hasError('color')) {
                                    <div class="error">Farbe ist erforderlich!</div>
                                }
                            </div>
                            <div class="md:col-12">
                                <label class="label" for="description">Beschreibung</label>
                                <textarea id="description" nbInput fullWidth formControlName="description"></textarea>
                            </div>
                            @if (showVisibility()) {
                                <div class="md:col-12">
                                    <nb-checkbox formControlName="publicFolder" data-cy="public-folder-checkbox">
                                        Öffentlich
                                    </nb-checkbox>
                                    <div class="visibility-hint">
                                        Öffentliche Ordner sehen auch Dienstleister und der QR-Code-Zugang, Dienstleister
                                        können dort Dokumente hochladen. Private Ordner sehen nur interne und externe Mandanten.
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </form>
            }
            @if (isRootFolder()) {
                <div class="sub-folder-section">
                    <div class="section-header">
                        <div class="section-title">Unterordner</div>
                        @if (canEdit() && isEditing) {
                            <button nbButton outline status="primary" size="small" (click)="openCreateSubFolderDialog()">
                                <nb-icon icon="plus-outline" pack="eva"></nb-icon>
                                Unterordner anlegen
                            </button>
                        }
                    </div>
                    <div class="section-hint">
                        Unterordner werden automatisch in allen {{ targetLabel() }} dieses Ordners angelegt.
                    </div>
                    <div class="sub-folders">
                        @for (subFolder of subFolders() ?? []; track subFolder.id) {
                            <div class="sub-folder">
                                <nb-icon icon="folder-outline" pack="eva" [style.color]="subFolder.color"></nb-icon>
                                <div class="sub-folder-name">{{ subFolder.name }}</div>
                                <div class="flex-grow"></div>
                                @if (canEdit() && isEditing) {
                                    <button nbButton ghost status="primary" size="small"
                                            (click)="openRenameSubFolderDialog(subFolder)"
                                            nbTooltip="Unterordner bearbeiten" nbTooltipPlacement="bottom">
                                        <nb-icon icon="edit-outline" pack="eva"></nb-icon>
                                    </button>
                                    <button nbButton ghost status="danger" size="small"
                                            (click)="confirmDeleteSubFolder(subFolder)"
                                            nbTooltip="Unterordner löschen" nbTooltipPlacement="bottom">
                                        <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                                    </button>
                                }
                            </div>
                        } @empty {
                            @if (subFolders()?.length === 0) {
                                <div class="empty-hint">Keine Unterordner definiert.</div>
                            }
                        }
                    </div>
                </div>
            }
        </nb-card-body>
        @if (canEdit()) {
            <nb-card-footer>
                <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern
                </button>
                <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
            </nb-card-footer>
        }
    </nb-card>
</div>
